import { Record as record } from 'immutable';

import trainTime from '../../../../lib/TrainTime';
import { getDefaults, getResolvers } from '../../../../helpers/Records';
import { construct, resolve, resolveAll } from '../../../../helpers/LinkMapper';

import Ticket from './Ticket';

const fieldSchema = {
    "journeyPatternId": [resolve.with(Number)],
    "processingDate": [resolve.with(trainTime)],
    "status": [resolve.with(String)],
    "journeyCount": [resolve.with(Number)],
    "incompleteJourneyCount": [resolve.with(Number)],
    "autofillJourneyCount": [resolve.with(Number)],
    "tickets": [resolveAll.as(Ticket)]
};

class JourneyPattern extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(JourneyPattern, json, getResolvers(fieldSchema));
    }
}

export default JourneyPattern;
